import MediaMasterCreatePage from './MediaMasterCreatePage';

export default MediaMasterCreatePage;
